export const HIPAA_SETUP_PATH = '/accounts/hipaasetup';

export const STEP_ERROR = 0;
export const STEP_ONE = 1;
export const STEP_TWO = 2;
export const STEP_THREE = 3;
export const STEP_FOUR = 4;
export const STEP_FIVE = 5;
export const STEP_SIX = 6;
